module.exports = __webpack_public_path__ + "static/img/COSTA_H5.ff5276f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/COSTA_H5.png
// module id = wm44
// module chunks = 34